import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** eye, show. Decorative line icon; always pair with a visible text label. */
export function EyeIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M2.5 12S6 5.8 12 5.8 21.5 12 21.5 12 18 18.2 12 18.2 2.5 12 2.5 12z" />
      <circle cx="12" cy="12" r="2.8" />
    </IconSvg>
  )
}
